module.exports = __webpack_public_path__ + "static/android-chrome-512x512-44ff4b0d520b81946bcfed60ad299ccd.png";